/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingEntityQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("BillingEntityQueryOperator");
    }

    getFixupPrototypeFunction() { return BillingEntityQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<BillingEntityQueryOperator>): BillingEntityQueryOperator {
        let obj = Object.assign(new BillingEntityQueryOperator(), model);
        BillingEntityQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingEntityQueryOperator>): BillingEntityQueryOperator {
        if (!model) return null;
        return BillingEntityQueryOperator.newInstance(<BillingEntityQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingEntityQueryOperator) {
        if (!obj) return;

        models.BillingEntityQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingEntityQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingEntityQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Billing entities to include
     */
    billing_entities: Array<string>;

}
